import queryParameters from './app/consts/route/queryParameters';
import log from './app/services/logger/log';
import marketService from './app/services/marketService';
import storageService from './app/services/storage/storageService';
import urlUtils from './app/utils/urlUtils';

export const setupManifest = () => {
    try {
        const manifest = getManifestData();

        addManifest(manifest, '#manifest');
    } catch (e) {
        log.info(`setupManifest error: ${e}`);
    }
};

const MANIFEST = {
    short_name: 'IQOS',
    name: 'IQOS Connect WEB',
    icons: [
        {
            src: process.env.PUBLIC_URL + '/icons/pwa-iqos-icon.svg',
            sizes: 'any',
            type: 'image/svg+xml',
        },
        {
            src: process.env.PUBLIC_URL + '/icons/pwa-iqos-icon_192.png',
            sizes: '192x192',
            type: 'image/png',
        },
        {
            src: process.env.PUBLIC_URL + '/icons/pwa-iqos-icon_512.png',
            sizes: '512x512',
            type: 'image/png',
            purpose: 'any maskable',
        },
    ],
    display: 'standalone',
    orientation: 'any',
    start_url: process.env.PUBLIC_URL,
    theme_color: '#ffffff',
    background_color: '#fffdfb',
};

const getManifestData = () => {
    const [languageFromUrl] = urlUtils.getDataFromUrl(queryParameters.LANGUAGE);
    const languageFromLocalStorage = storageService.getLanguageCodeFromLocalStorage();
    const language = languageFromUrl || languageFromLocalStorage;
    const marketCode = marketService.getMarketCode();

    MANIFEST.start_url =
        `${MANIFEST.start_url}/${marketCode}` + (language ? `/?${queryParameters.LANGUAGE}=${language}` : '/');

    return MANIFEST;
};

const addManifest = (manifest, selector) => {
    const stringManifest = JSON.stringify(manifest);
    const blob = new Blob([stringManifest], {type: 'application/json'});
    const manifestURL = URL.createObjectURL(blob);

    document.querySelector(selector)?.setAttribute('href', manifestURL);
};
